import { render, staticRenderFns } from "./InformDiners.vue?vue&type=template&id=5bf75ac6&"
import script from "./InformDiners.vue?vue&type=script&lang=js&"
export * from "./InformDiners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports